import React from 'react';
import { IconProps } from './IconTypes';

const AuroraLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8,86 C18,40 38,18 50,18 C62,18 82,40 92,86 L84,86 C76,52 62,30 50,30 C38,30 24,52 16,86 Z" />
      <path d="M22,86 C30,56 42,40 50,40 C58,40 70,56 78,86 L70,86 C64,64 56,50 50,50 C44,50 36,64 30,86 Z" />
      <path d="M38,86 C42,72 46,62 50,62 C54,62 58,72 62,86 L56,86 C54,80 52,76 50,76 C48,76 46,80 44,86 Z" />
    </svg>
  );
};

export default AuroraLogo;
